import { createFileRoute, Outlet } from "@tanstack/react-router";
import PageLayout from "@/components/layout/PageLayout";
import AdminSidebar from "@/components/layout/AdminSidebar";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

export const Route = createFileRoute("/_protected/admin")({
	component: () => (
		<ProtectedRoute>
			<PageLayout>
				<div className="flex h-screen">
					<AdminSidebar />
					<main className="flex-1 overflow-auto">
						<Outlet />
					</main>
				</div>
			</PageLayout>
		</ProtectedRoute>
	),
});
